import React from "react";
import { InfiniteScroll, Button } from "nq-component";
import BiomentricFacePresenter from "./BiomentricFacePresenter";
import BaseListPage from "../../base/BaseListPage";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../usecases/object";
import CardView from "../../components/common/CardView";
import Table from "../../components/Table";
import withRouter from "../../withRouter";
import { FloatingForm } from "../../components/common/Converter";
import DateRangePicker from "../../components/common/DateRangePicker";
import NavBar from "../../components/navigation";
import Progress from "../../components/Progress";

class BiometricFacePage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new BiomentricFacePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      objects: [],
      count: 0,
      limit: 10,
      current: 1,
    };
  }

  getCollectionName() {
    return "biometric_face_capture";
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  handleViewObj(object) {
    // window.open(object.faceCapture, "_blank", "noopener,noreferrer");
    this.setState({ viewModal: true, link: object.faceCapture });
  }

  onChangeOption(field, value) {
    this.setState({ [field]: value });
    this.onChangeFilter("String", value, field);
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, count, limit, current, loading } = this.state;
    if (!schema) return <Progress />;
    // const user = this.getCurrentUser();
    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll className="h-100" loadMore={this.loadMore.bind(this)}>
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} System Administration {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    {schema.label}
                  </span>
                </p>
              </div>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center gap-3">
                    <h4 className="text-primary">{schema.label}</h4>
                    <div>
                      {/* <InputFactory
                        type="Date"
                        onChange={(value) =>
                          this.onChangeOption("createdAt", value)
                        }
                      /> */}
                      <DateRangePicker
                        fields={["createdAt", "updatedAt", ""]}
                        onFilter={(filterObj) => {
                          try {
                            const update = new Date(filterObj.updatedAt.$lte);
                            update.setDate(update.getDate() + 1);
                            const formattedDate = update
                              .toISOString()
                              .split("T")[0];
                            const filterStartDate = {
                              createdAt: {
                                $lte: formattedDate,
                                $gte: filterObj.createdAt.$gte,
                              },
                            };
                            this.searchSubmit(filterStartDate);
                            this.setState({ filters: filterStartDate });
                          } catch (e) {
                            this.searchSubmit({});
                            this.setState({ filters: {} });
                          }
                        }}
                      />
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                progress={loading}
                fields={schema.fields}
                objectData={this.handleViewObj.bind(this)}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                actionsList={[
                  {
                    label: <i className="bi bi-search">View</i>,
                    actionType: "object",
                  },
                ]}
                loadPagination={this.onClickPagination.bind(this)}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "updatedAt", "acl", "fileName"]
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
        {this.state.viewModal && (
          <FloatingForm width="20rem">
            <CardView style={{ padding: 0 }}>
              <div className="d-grid">
                {/* <div className="row"> */}
                <img width="100%" src={this.state.link} alt="biometric" />
                {/* <div className="col-lg-6 pe-5 ps-5">{printContent()}</div> */}
                {/* </div> */}
                <div className="w-100 d-flex justify-content-end gap-4 mb-3 pe-3 mt-3">
                  <Button
                    className="btn btn-primary"
                    onClick={() => {
                      this.setState({ viewModal: false });
                    }}
                  >
                    Ok
                  </Button>
                </div>
              </div>
            </CardView>
          </FloatingForm>
        )}
      </>
    );
  }
}

export default withRouter(BiometricFacePage);
